import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export async function subscribe({ email, name, source }) {
  const { data } = await api.post("/subscribe", { email, name, source });
  return data;
}

// ---------- Blog (public) ----------
export async function fetchArticles() {
  const { data } = await api.get("/blog/articles");
  return data;
}

export async function fetchArticle(slug) {
  const { data } = await api.get(`/blog/articles/${slug}`);
  return data;
}

export function coverImageSrc(article) {
  if (!article?.cover_image_url) return null;
  return `${BACKEND_URL}${article.cover_image_url}`;
}

// ---------- Admin auth ----------
export async function adminLogin(email, password) {
  const { data } = await api.post("/auth/login", { email, password });
  return data;
}

export async function adminLogout() {
  const { data } = await api.post("/auth/logout", {});
  return data;
}

export async function adminMe() {
  const { data } = await api.get("/auth/me");
  return data;
}

// ---------- Admin article CRUD ----------
function articleFormData({ title, authorName, date, body, coverImageFile, isFeatured, coverImageFocalY }) {
  const fd = new FormData();
  fd.append("title", title);
  fd.append("author_name", authorName);
  fd.append("date", date);
  fd.append("body", body);
  fd.append("is_featured", isFeatured ? "true" : "false");
  fd.append("cover_image_focal_y", String(coverImageFocalY ?? 50));
  if (coverImageFile) fd.append("cover_image", coverImageFile);
  return fd;
}

export async function createArticle(fields) {
  const { data } = await api.post("/admin/articles", articleFormData(fields));
  return data;
}

export async function updateArticle(id, fields) {
  const { data } = await api.put(`/admin/articles/${id}`, articleFormData(fields));
  return data;
}

export async function toggleArticleFeatured(id, isFeatured) {
  const { data } = await api.patch(`/admin/articles/${id}/feature`, { is_featured: isFeatured });
  return data;
}

export async function deleteArticle(id) {
  const { data } = await api.delete(`/admin/articles/${id}`);
  return data;
}
